import React, { useState } from 'react';
import { FACTOR_KEYS } from '../data/defaultInputs';
import { factorGuides } from '../data/factorGuides';
import FactorCard from './FactorCard';
import FactorDrawer from './FactorDrawer';
import DiseaseSelector from './DiseaseSelector';
import StepHero from './StepHero';

export default function StepQuality({ inputs, onChange, onOpenPresetPicker, glowField }) {
  const [openFactor, setOpenFactor] = useState(null);
  const openIndex = openFactor ? FACTOR_KEYS.indexOf(openFactor) + 1 : 0;

  return (
    <section data-testid="step-quality">
      <StepHero
        sectionLabel="Data quality"
        title={<>Rate your data on the <em style={emStyle}>five quality factors.</em></>}
        lede="Click any card to read what each level means, see how buyers interpret it, and what the comparable benchmarks look like. Numbers compound multiplicatively — small lifts at the high end make a big difference."
        eyebrowAction={onOpenPresetPicker ? (
          <button type="button" onClick={onOpenPresetPicker} style={presetLinkStyle} data-testid="use-preset-link">
            Use preset →
          </button>
        ) : null}
      />

      <DiseaseSelector
        value={inputs.diseaseCategory}
        onChange={(v) => onChange('diseaseCategory', v)}
        samples={inputs.samples}
        rarity={inputs.rarity}
        usefulness={inputs.usefulness}
      />

      <div style={gridStyle}>
        {FACTOR_KEYS.map((factor) => (
          <FactorCard
            key={factor}
            factor={factor}
            value={inputs[factor]}
            summary={factorGuides[factor]?.scale?.[inputs[factor] - 1]}
            glow={glowField === factor}
            onClick={() => setOpenFactor(factor)}
          />
        ))}
      </div>

      {openFactor && (
        <FactorDrawer
          factor={openFactor}
          factorIndex={openIndex}
          totalFactors={FACTOR_KEYS.length}
          initialValue={inputs[openFactor]}
          onApply={(v) => {
            onChange(openFactor, v);
            setOpenFactor(null);
          }}
          onClose={() => setOpenFactor(null)}
        />
      )}
    </section>
  );
}

const emStyle = { fontStyle: 'italic', color: 'var(--accent)' };
const presetLinkStyle = {
  background: 'transparent',
  border: 'none',
  padding: 0,
  fontFamily: 'var(--font)',
  fontSize: '13px',
  color: 'var(--accent)',
  fontWeight: 500,
  cursor: 'pointer',
  textDecoration: 'underline',
  textUnderlineOffset: '3px',
};
const gridStyle = { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '14px' };
